import {type BaseEvent, type Event, EventDispatcher as ThreeEventDispatcher} from 'three'
import Utils from './util'

export class RenderEventDispatcher<E extends BaseEvent = Event> extends ThreeEventDispatcher<E> {
  constructor() {
    super()
  }

  once(type: Extract<keyof E, string>, fn: (e?: BaseEvent) => void) {
    const callback = (e: BaseEvent) => {
      fn(e)
      // Don't mutate the array while we iterate it,
      // cause this to eval sometime after
      // this chain of event dispatch finishes
      // in `THREE.EventDispatcher.dispatchEvent'
      Utils.defer(() => {
        this.removeEventListener(type, callback)
      })
    }
    this.addEventListener(type, callback)
  }
}
